import React from "react";
import { NavLink } from "react-router-dom";
import "../../scss/dashboard/dashMenu.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faFileAlt,
  faCog,
  faShoppingBasket,
} from "@fortawesome/free-solid-svg-icons";
// import { IoMdSettings } from "@react-icons/all-files/io/IoMdSettings";
// import { MdShoppingBasket } from "@react-icons/all-files/md/MdShoppingBasket";
// import { IoMdDocument } from "@react-icons/all-files/io/IoMdDocument";
// import { AiFillCheckCircle } from "@react-icons/all-files/ai/AiFillCheckCircle";
function DashMenu() {
  return (
    <div className="dashmenu-container">
      <div className="dashMenu">
        <NavLink
          className="dashMenuButton"
          to="/lawyers"
          exact={true}
          activeClassName="menuActive1"
          style={{ textDecoration: "none" }}
        >
          <FontAwesomeIcon icon={faCheckCircle} />

          <span>Inicio</span>
        </NavLink>
        <NavLink
          className="dashMenuButton"
          to="/lawyers/templates"
          activeClassName="menuActive"
          isActive={(match, location) => {
            return [
              "/lawyers/templates/published",
              "/lawyers/templates/in-review",
              "/lawyers/templates/create",
            ].includes(location.pathname);
          }}
          style={{ textDecoration: "none" }}
        >
          <FontAwesomeIcon icon={faFileAlt} />
          <span>Mis Plantillas</span>
        </NavLink>
        <NavLink
          className="dashMenuButton"
          to="/lawyers/settings"
          activeClassName="menuActive"
          style={{ textDecoration: "none" }}
        >
          <FontAwesomeIcon icon={faCog} />
          <span>Ajustes</span>
        </NavLink>
        <NavLink
          className="dashMenuButton"
          to="/lawyers/templates/sold"
          activeClassName="menuActive2"
          style={{ textDecoration: "none" }}
        >
          {/* <MdShoppingBasket style={{ color: "#969696" }} /> */}
          <FontAwesomeIcon icon={faShoppingBasket} />
          <span>Plantillas Vendidas</span>
        </NavLink>
      </div>
    </div>
  );
}

export default DashMenu;
